import { withRouter, Redirect } from 'react-router-dom';
import React from 'react';
import Popup from 'react-popup';
import intl from 'react-intl-universal';
import { connect } from 'react-redux';
import {
	getOrder,
	finishOrder,
	selectOrder,
	releaseOrder,
	printErrorLabel,
	sendProductShortages,
	returnToHome,
	finishOrderSkipSummary,
} from '../actions/PackActions';
import { selectShipping, deleteShipping, generateReturnWaybill, createNewShipping, saveShipping, getShipping } from '../actions/ShippingActions';
import ParcelTable from './ParcelTable';
import ProgressBar from './ProgressBar';
import ProductListItem from './ProductListItem';
import { getProductsWithShortages, buildShortagesOrder, getShortagesNote } from '../utils/shortagesUtils';
import { updateCounter } from '../utils/CountersUtils';
import { b64EncodeUnicode, handleLogoUrl } from '../utils/Tools';
import { ReactComponent as Check } from '../assets/check.svg';
import { parseBarcode } from '../utils/ParseBarcode';
import sound_not_found from '../assets/not_found_audio.mp3';
import sound_correct_scan from '../assets/correct_scan.mp3';
import sound_finish_packing from '../assets/finish_packing_audio.mp3';
import sound_speaky_peaky_one from '../assets/sneaky_peaky_1.mp3';
import sound_speaky_peaky_two from '../assets/sneaky_peaky_2.mp3';
import { isElementScanRequired, collectManualConfirmations, setManualConfirmation } from '../utils/ScanRequirementUtils';
require('./ShippingList');
require('./MaterialsList');
require('./Substitutes');
require('./ShippingDataForm');

function getProductListItem(prod, parent, group_treshold, index) {
	// render substitutes
	const orderSubstitutes = parent.getOrderSubstitutes(prod.line_id) || {};
	const product = {
		...prod,
		...(prod.substitute_products
			? {
					substitute_products: prod.substitute_products.map(sub => ({
						...sub,
						value: (orderSubstitutes || {})[sub.product_id],
					})),
			  }
			: {}),
	};
	if (product.substitute_products && product.substitute_products.some(sub => sub.value && sub.value > 0)) {
		let arr = [];
		product.substitute_products
			.filter(sub => sub.value && sub.value > 0)
			.forEach(sub => {
				arr.push(
					<ProductListItem
						key={'sub_' + index + '_' + product.line_id + '.' + sub.product_id}
						product={{
							...product,
							default_code: sub.default_code,
							quote_default_code: sub.default_code,
							product_name: sub.description,
							product_id: sub.product_id,
							product_uom_qty: sub.value,
							line_qty: product.product_uom_qty,
						}}
						qty={sub.value}
						supercount={true}
						productTracking={false}
						parent={parent}
					/>
				);
			});
		return arr;
	}
	// render substitutes END

	const productTracking = product.product_tracking !== 'none';
	const isLotTracking = product.product_tracking === 'lot';
	const isSerialTracking = product.product_tracking === 'serial';
	
	// Products with a packaging multiplier are always grouped by package,
	// regardless of the supercount threshold - the threshold only applies
	// to products without a packaging multiplier.
	const packagingQty = Number(product.packaging_qty) || 0;
	const usePackaging = !productTracking && packagingQty > 1;

	let supercount = false;
	if (!usePackaging && group_treshold && product.product_uom_qty >= group_treshold) {
		supercount = true;
	}

	let k = 1;
	if (usePackaging) {
		let arr = [];
		let remaining = product.product_uom_qty;
		while (remaining > 0) {
			k++;
			const boxQty = remaining >= packagingQty ? packagingQty : remaining;
			arr.push(
				<ProductListItem
					key={'main_' + index + '_' + product.line_id + '.' + product.product_id + '.' + k}
					product={product}
					qty={boxQty}
					supercount={supercount}
					productTracking={productTracking}
					isLotTracking={false}
					isPackagingBox={true}
					parent={parent}
				/>
			);
			remaining -= boxQty;
		}
		return arr;
	} else if (supercount) {
		k++;
		return (
			<ProductListItem
				key={'main_' + index + '_' + product.line_id + '.' + product.product_id + '.' + k}
				product={product}
				qty={product.product_uom_qty}
				supercount={supercount}
				productTracking={productTracking}
				isLotTracking={isLotTracking}
				parent={parent}
			/>
		);
	} else {
		let arr = [];
		for (var i = 0; i < product.product_uom_qty; i++) {
			k++;
			arr.push(
				<ProductListItem
					key={'main_' + index + '_' + product.line_id + '.' + product.product_id + '.' + k}
					product={product}
					qty={product.product_uom_qty - i < 1 ? Math.round((product.product_uom_qty - i) * 100) / 100 : 1}
					supercount={supercount}
					productTracking={productTracking}
					isLotTracking={false}
					parent={parent}
				/>
			);
		}
		return arr;
	}
}

const inpost_size_options = [
	['A', 'A'],
	['B', 'B'],
	['C', 'C'],
];

const orlen_size_options = [
	['S', 'S'],
	['M', 'M'],
	['L', 'L'],
	['Mini', 'MINI'],
];

const pp_size_options = [
	['XS', 'xsmall'],
	['S', 'small'],
	['M', 'medium'],
	['L', 'large'],
	['XL', 'xlarge'],
	['XXL', 'xxlarge'],
];

const wza_size_options = [
	['S', 's'],
	['M', 'm'],
	['L', 'l'],
];

const wrong_ean_audio = new Audio(sound_not_found);
const correct_scan_audio = new Audio(sound_correct_scan);
const finish_packing_audio = new Audio(sound_finish_packing);

const speaky_peaky_one_audio = new Audio(sound_speaky_peaky_one);
const speaky_peaky_two_audio = new Audio(sound_speaky_peaky_two);

const is_local_host_or_testerp =
	window.location.href.includes('localhost') || window.location.href.includes('testerp13-dev');

const mapStateToProps = state => ({
	authenticated: state.auth.session.id !== false,
	product_confirmation_method: state.config.product_confirmation_method,
	auto_select_first: state.config.auto_select_first,
	verify_qty: !!state.config.verify_qty,
	confirm_note: state.config.confirm_note,
	show_company: state.config.show_company,
	show_shop: state.config.show_shop,
	carrier_selection: state.config.carrier_selection,
	inventory_manage_materials: state.config.inventory_manage_materials,
	packing_zone_inventory_manage_materials: state.config.packing_zone_inventory_manage_materials,
	use_packing_zone_error_label: state.config.use_packing_zone_error_label,
	material_products: state.config.material_products,
	auto_check_all_products: state.config.auto_check_all_products,
	product_shortages_in_packing_zone: state.config.product_shortages_in_packing_zone,
	inpost_dostawy: state.config.inpost_dostawy || [],
	pp_dostawy: state.config.pp_dostawy || [],
	wza_dostawy: state.config.wza_dostawy || [],
	orlen_dostawy: state.config.orlen_dostawy || [],
	add_package: state.config.add_package,
	add_delivery: state.config.add_delivery,
	group_treshold: state.config.group_treshold ? parseInt(state.config.group_treshold) : false,
	pack: state.router.location.query.pack ? parseInt(state.router.location.query.pack) : false,
	order_id: state.router.location.query.order ? parseInt(state.router.location.query.order) : false,
	order: state.pack.order,
	processing: state.pack.processing,
	last_scanned: state.pack.last_scanned,
	shipping: state.shipping.shipping,
	inventory_materials_shipment_package_sizes: state.config.inventory_materials_shipment_package_sizes,
	shipping_data: state.shipping.shipping_data,
	available_carriers: state.config.available_carriers,
	show_package_button_in_packing_zone: state.config.show_package_button_in_packing_zone,
	scan_bundle_element_as_single_qty: state.config.scan_bundle_element_as_single_qty,
	bundle_select: state.config.bundle_select || false,
	packing_zone_dont_show_summary: state.config.packing_zone_dont_show_summary,
	packing_zone_editable_notes: state.config.packing_zone_editable_notes,
	simple_shipment_sizes: state.config.simple_shipment_sizes,
	packing_zone_show_cod_warning_popup: state.config.packing_zone_show_cod_warning_popup,
	show_generate_return_waybill: state.config.show_generate_return_waybill,
	packing_zone_show_warning_non_udi: state.config.packing_zone_show_warning_non_udi,
	show_grouped_counter: state.config.show_grouped_counter || false,
	shortcuts: state.config.shortcuts,
	close_order_in_packing_zone_after_all_products_scanned:
      state.config.close_order_in_packing_zone_after_all_products_scanned
});

const mapDispatchToProps = dispatch => ({
	getOrderAction: (code, id) => dispatch(getOrder(code, id)),
	finishOrderAction: data => dispatch(finishOrder(data)),
	sendProductShortages: data => dispatch(sendProductShortages(data)),
	selectOrderAction: () => dispatch(selectOrder()),
	selectShippingAction: id => dispatch(selectShipping(id)),
	createNewShippingAction: order_id => dispatch(createNewShipping(order_id)),
	deleteShippingAction: id => dispatch(deleteShipping(id)),
	generateReturnWaybillAction: id => dispatch(generateReturnWaybill(id)),
	releaseOrderAction: order_id => dispatch(releaseOrder(order_id)),
	printErrorLabelAction: order_id => dispatch(printErrorLabel(order_id)),
	returnToHomeAction: () => dispatch(returnToHome()),
	finishOrderSkipSummaryAction: data => dispatch(finishOrderSkipSummary(data)),
	getShippingAction: (id, order_id) => dispatch(getShipping(id, order_id)),
	saveShippingAction: (id, data, order_id) => dispatch(saveShipping(id, data, order_id)),
});

class OrderComponent extends React.Component {
	constructor() {
		super();
		this.deliveryDataLoadedForOrder = null;
		this.deliveryDataLoadingForOrder = null;
		this.state = {
			code: '',
			progress: 0,
			valid: false,
			orderSubstitutes: {},
			shortagesButtonClicked: false,
			shortagesNextPoint: false,
			isNonStandardInputChecked: false,
			parcelRows: [],
			errorParcelIndexes: [],
			isSelectDisabled: false,
			selectedCarrierId: '',
			deliveryData: null,
		};
	}

	buildDeliveryData = (order, shippingData = {}) => ({
		delivery_name: shippingData.receiver_name || order.delivery_name || '',
		delivery_street: shippingData.receiver_street || order.delivery_street || '',
		delivery_zip: shippingData.receiver_zip || order.delivery_zip || '',
		delivery_city: shippingData.receiver_city || order.delivery_city || '',
		delivery_phone: shippingData.receiver_phone || order.delivery_phone || '',
		delivery_email: shippingData.receiver_email || order.delivery_email || '',
	});

	setDeliveryDataFromShipping = (order, shippingData = null) => {
		this.setState({
			deliveryData: this.buildDeliveryData(order, shippingData || {}),
		});
		this.deliveryDataLoadedForOrder = order.id;
	};

	getDeliveryDataForDisplay = order => {
		const { deliveryData } = this.state;
		return deliveryData || this.buildDeliveryData(order);
	};

	getDeliveryDiff = (order, deliveryData) => {
		// Odoo zwraca false dla pustych pól, a buildDeliveryData normalizuje je do ''
		const original = this.buildDeliveryData(order);
		return {
			name: original.delivery_name !== deliveryData.delivery_name,
			street: original.delivery_street !== deliveryData.delivery_street,
			zip: original.delivery_zip !== deliveryData.delivery_zip,
			city: original.delivery_city !== deliveryData.delivery_city,
			phone: original.delivery_phone !== deliveryData.delivery_phone,
			email: original.delivery_email !== deliveryData.delivery_email,
		};
	};

	hasAnyDeliveryDiff = diff => !!(diff.name || diff.street || diff.zip || diff.city || diff.phone || diff.email);

	loadDeliveryDataFromShipping = order => {
		const { inventory_materials_shipment_package_sizes, getShippingAction } = this.props;
		if (!inventory_materials_shipment_package_sizes || !order || !order.id) {
			return;
		}
		if (this.deliveryDataLoadedForOrder === order.id || this.deliveryDataLoadingForOrder === order.id) {
			return;
		}
		if (!order.shipping_order_ids || order.shipping_order_ids.length === 0) {
			this.setDeliveryDataFromShipping(order);
			return;
		}
		const shippingId = order.shipping_order_ids[0].id;
		this.deliveryDataLoadingForOrder = order.id;
		getShippingAction(shippingId, order.id)
			.then(shippingData => {
				this.setDeliveryDataFromShipping(order, shippingData);
			})
			.catch(() => {
				this.setDeliveryDataFromShipping(order);
			})
			.finally(() => {
				this.deliveryDataLoadingForOrder = null;
			});
	};

	componentDidMount() {
		const {
			getOrderAction,
			authenticated,
			order_id,
			order,
			last_scanned,
			auto_select_first,
			packing_zone_show_cod_warning_popup,
		} = this.props;

		if (authenticated && !order) {
			getOrderAction(false, order_id);
		}

		if (auto_select_first && order && last_scanned) {
			const checkbox = this.findCheckbox(last_scanned);
			if (checkbox) {
				checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
				this.simulateCheckboxClickByBarcode(last_scanned);
				this.playScanSound();
			}
		}

		if (packing_zone_show_cod_warning_popup && order && order.is_cod) {
			this.codAlert();
		}

		if (order && order.id) {
			this.loadDeliveryDataFromShipping(order);
			// orders without checkboxes (e.g. service only) would never enable "Dalej"
			this.toggleConfirmButton();
		}
	}

	componentDidUpdate(prevProps) {
		const { product_confirmation_method, shipping, auto_check_all_products, order } = this.props;
		const dontScanProducts = order.dont_scan_products;

		if (['scan', 'scan_click'].includes(product_confirmation_method) && shipping === false) {
			// Disable scanner input focus if edit parcel table
			const activeEl = document.activeElement;
			if (!activeEl.closest('.ignore-scanner-focus')) {
				document.getElementById('scanner').focus();
			}
		}

		if (order && (!prevProps.order || prevProps.order.id !== order.id) && order.carrier_id) {
			this.setState({ selectedCarrierId: order.carrier_id });
		}

		if (order && (!prevProps.order || prevProps.order.id !== order.id)) {
			this.deliveryDataLoadedForOrder = null;
			this.deliveryDataLoadingForOrder = null;
			this.setState({ deliveryData: null }, () => this.loadDeliveryDataFromShipping(order));
			this.toggleConfirmButton();
		}

		if (auto_check_all_products || dontScanProducts) {
			this.checkAllProducts(!dontScanProducts);
		}
	}

	handleNonStandardCheckedChange = checked => {
		this.setState({ isNonStandardInputChecked: checked });
	};

	codAlert = () => {
		Popup.create({
			content: intl.get('Uwaga! Zamówienie jest płatne przy odbiorze.'),
			buttons: {
				right: [
					{
						text: 'OK',
						className: 'ok',
						key: 'enter',
						action: function () {
							Popup.close();
						},
					},
				],
			},
		});
	};

	deselectOrder = event => {
		const { selectOrderAction, releaseOrderAction, order_id, pack, returnToHomeAction } = this.props;
		if (pack == -1) {
			returnToHomeAction();
		} else {
			releaseOrderAction(order_id);
			selectOrderAction();
		}
	};

	doToggleCheckbox = (checkbox, parent) => {
		checkbox.classList.toggle('checked');

		document.querySelectorAll('.produkt').forEach(el => el.classList.remove('last_scanned'));
		checkbox.closest('[data-barcode]').classList.add('last_scanned');

		if (parent.querySelector('.bundleItemList')) {
			if (checkbox.classList.contains('mainCheckbox')) {
				document
					.querySelectorAll('.bundleItemList .checkbox')
					.forEach(el => el.classList.toggle('checked', checkbox.classList.contains('checked')));
			} else {
				parent
					.querySelector('.product_checkbox .checkbox')
					.classList.toggle('checked', !parent.querySelector('.bundleItemList .checkbox:not(.checked)'));
			}
		}

		this.toggleConfirmButton();
	};

	toggleCheckbox = (checkbox, parent, scrollInto = false) => {
		const cnt = this.getProductCountString(checkbox, parent);
		const { verify_qty, group_treshold, show_grouped_counter } = this.props;
		const bundleQty = this.getBundleQty(checkbox);

		const isChecked = checkbox.classList.contains('checked');
		const isSupercount = parent.classList.contains('supercount');
		const isGroupThresholdReached = bundleQty >= group_treshold;
		const canSkipConfirmation = !verify_qty || (!isSupercount && !isGroupThresholdReached) || isChecked;

		if (canSkipConfirmation && !show_grouped_counter) {
			this.doToggleCheckbox(checkbox, parent);
			console.log('Checkbox toggled without confirmation:', checkbox, parent);
			if (scrollInto) parent.scrollIntoView(true);
			return;
		}

		if (!verify_qty && show_grouped_counter) {
			console.log('Grouped counter incremented without verification');
			this.incrementGroupedCounter(parent);
			return;
		}

		if (verify_qty) {
			console.log('Verification required for checkbox:', checkbox, parent);
			if (show_grouped_counter) {
				console.log('Grouped counter incremented with verification');
				this.incrementGroupedCounter(parent);
			} else {
				console.log('Showing confirmation popup');
				this.showConfirmationPopup(cnt, () => {
					this.doToggleCheckbox(checkbox, parent);
					if (scrollInto) parent.scrollIntoView(true);
				});
			}
		}
	};

	getBundleQty = checkbox => {
		if (checkbox.classList.contains('multiproduct')) {
			return parseInt(checkbox.closest('tr').getAttribute('data-qty')) || 0;
		}
		return 0;
	};

	getProductCountString = (checkbox, parent) => {
		const base = parent.getAttribute('data-prods') || '1';
		const bundleQty = this.getBundleQty(checkbox);
		return bundleQty ? `${base} x ${bundleQty}` : base;
	};

	incrementGroupedCounter = parent => {
		const button = parent.querySelector('.grouped_counter__increment');
		if (button) {
			button.click();
			console.log('Grouped counter incremented');
		}
	};

	showConfirmationPopup = (cnt, onConfirm) => {
		Popup.create({
			content: intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', { cnt }),
			buttons: {
				right: [
					{
						text: intl.get('Tak'),
						key: 'enter',
						action: function () {
							Popup.close();
							onConfirm();
						},
					},
					{
						text: intl.get('Nie'),
						className: 'cancel-button',
						action: function () {
							Popup.close();
						},
					},
				],
			},
		});
	};

	printErrorLabel = () => {
		const { order_id, printErrorLabelAction } = this.props;
		Popup.create({
			content: intl.get('Na pewno chcesz drukować etykietę zastępczą?'),
			buttons: {
				right: [
					{
						text: intl.get('Tak'),
						key: 'enter',
						action: function () {
							Popup.close();
							printErrorLabelAction(order_id);
						},
					},
					{
						text: intl.get('Anuluj'),
						className: 'cancel-button',
						action: function () {
							Popup.close();
						},
					},
				],
			},
		});
	};

	handleShortagesOrder = (productsWithShortages, note) => {
		const { order_id, sendProductShortages } = this.props;
		const shortagesOrder = buildShortagesOrder(order_id, productsWithShortages, note);
		sendProductShortages(shortagesOrder);
	};

	checkInputValue = () => {
		const productsWithShortages = getProductsWithShortages();
		const hasShortages = productsWithShortages.length > 0;

		this.setState({ shortagesNextPoint: hasShortages }, () => {
			this.toggleConfirmButton();
		});
	};

	getProductsWithShortages = () => {
		const inputs = document.querySelectorAll('.shortages-input');
		const productsWithShortages = [];

		inputs.forEach(input => {
			const quantity = parseInt(input.value);
			if (quantity > 0) {
				const productCheckbox = input.closest('.product_checkbox');
				const lineId = productCheckbox.dataset.line;
				const productId = productCheckbox.dataset.product;

				productsWithShortages.push({
					line_id: lineId,
					product_id: productId,
					shortage_qty: quantity,
				});
			}
		});

		return productsWithShortages;
	};

	handleScanner = event => {
		const { order, material_products, packing_zone_show_warning_non_udi } = this.props;

		if (event.which !== 13) return;

		const input = event.target;
		let ean = input.value.trim();
		let originalCode = '';
		let codeWithoutZero = '';

		const parsed = parseBarcode(ean);
		const isUDI = this.isUDI(parsed);

		if (isUDI) {
			ean = parsed.EAN;
			originalCode = parsed.originalCode;
			codeWithoutZero = parsed.CODE_WITHOUT_ZERO;
		} else if (packing_zone_show_warning_non_udi) {
			this.handleNonUDIPopup();
			return;
		}

		if (this.handleShortcut(ean) || (originalCode && this.handleShortcut(originalCode))) {
			this.resetInput(input);
			return;
		}

		if (this.tryMatchMaterialProduct(ean, material_products)) {
			this.resetInput(input);
			return;
		}

		let checkbox = null;
		let matchedCode = null;

		const codesToCheck = [ean, originalCode, codeWithoutZero];
		for (let i = 0; i < codesToCheck.length; i++) {
			const currentCode = codesToCheck[i];
			checkbox = this.findCheckbox(currentCode);
			if (checkbox) {
				matchedCode = currentCode;
				break;
			}
		}

		if (!checkbox) {
			this.handleScanNotFound(input);
			this.resetInput(input);
			return;
		}

		// additional_barcodes
		let qtyToCheck = 1;
		let product = null;

		if (order && order.products && order.products.length) {
			for (let i = 0; i < order.products.length; i++) {
				const p = order.products[i];
				if (p.barcode === matchedCode) {
					product = p;
					break;
				}
				if (Array.isArray(p.additional_barcodes_ids)) {
					for (let j = 0; j < p.additional_barcodes_ids.length; j++) {
						const b = p.additional_barcodes_ids[j];
						if ((b.barcode || b) === matchedCode) {
							product = p;
							break;
						}
					}
					if (product) break;
				}
				if (!product && Array.isArray(p.items)) {
					for (let j = 0; j < p.items.length; j++) {
						const item = p.items[j];
						if (item.barcode === matchedCode) {
							product = item;
							break;
						}
						if (Array.isArray(item.additional_barcodes_ids)) {
							for (let k = 0; k < item.additional_barcodes_ids.length; k++) {
								const b = item.additional_barcodes_ids[k];
								if ((b.barcode || b) === matchedCode) {
									product = item;
									break;
								}
							}
						}
						if (product) break;
					}
					if (product) break;
				}
			}
		}

		if (product) {
			if (product.additional_barcodes_qtys &&
					product.additional_barcodes_qtys[matchedCode] != null) {
				const raw = product.additional_barcodes_qtys[matchedCode];
				const val = (raw && typeof raw === 'object') ? raw.parsedValue : raw;
				qtyToCheck = parseInt(val) || 1;
			} else if (Array.isArray(product.additional_barcodes_ids)) {
				for (let i = 0; i < product.additional_barcodes_ids.length; i++) {
					const b = product.additional_barcodes_ids[i];
					if ((b.barcode || b) === matchedCode && b.qty != null) {
						const val = (b.qty && typeof b.qty === 'object') ? b.qty.parsedValue : b.qty;
						qtyToCheck = parseInt(val) || 1;
						break;
					}
				}
			}
		}

		checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });

		const productEl = checkbox.closest('.produkt.ramka');
		if (productEl) {
			const isBundleItem = checkbox.classList.contains('multiproduct');
			const lineCounterEl = productEl.querySelector('.grouped_counter_count');
			if (!lineCounterEl || !(parseInt(lineCounterEl.dataset.count) || 0)) {
				setManualConfirmation(productEl, false);
			}
			if (isBundleItem) {
				const bundleItemEl = checkbox.closest('.bundleItem');
				const bundleItemCounter = bundleItemEl &&
					bundleItemEl.querySelector('.smaller.counter');
				if (bundleItemCounter) {
					const currentCount = parseInt(bundleItemCounter.dataset.count) || 0;
					const maxCount = parseInt(bundleItemCounter.dataset.destination) || 0;
					if (currentCount + qtyToCheck > maxCount) {
						this.handleScanNotFound(input);
						return;
					}
				}
				if (!bundleItemCounter || !(parseInt(bundleItemCounter.dataset.count) || 0)) {
					setManualConfirmation(bundleItemEl, false);
				}
				for (let i = 0; i < qtyToCheck; i++) {
					this.simulateCheckboxClickByBarcode(matchedCode);
				}
			} else {
				const counterEl = productEl.querySelector('.grouped_counter_count');
				if (counterEl) {
					const currentCount = parseInt(counterEl.dataset.count) || 0;
					const maxCount = parseInt(counterEl.dataset.destination) || 0;
					if (currentCount + qtyToCheck > maxCount) {
						this.handleScanNotFound(input);
						return;
					}
				}
				for (let i = 0; i < qtyToCheck; i++) {
					this.simulateCheckboxClickByBarcode(matchedCode);
				}
			}
		}

		this.resetInput(input);
		this.playScanSound();

		event.preventDefault();
		event.stopPropagation();
	};

	simulateCheckboxClickByBarcode(barcode) {
		const safeBarcode = `#${barcode}#`;
		const el = document.querySelector(`.checkbox[data-code-barcode*="${safeBarcode}"]:not(.checked)`);
		if (el) {
			el.click();
		} else {
			console.warn(`Nie znaleziono elementu dla kodu kreskowego: ${barcode}`);
		}
	}

	/**
	 * Resets the input field.
	 * @param {*} input - The input element to reset.
	 */
	resetInput = input => {
		input.value = '';
		input.focus();
	};

	/**
	 * Tries to match a material product by its EAN code.
	 * @param {*} ean - The EAN code to match.
	 * @param {*} products - The list of material products to search.
	 * @returns {boolean} - True if a matching product was found, false otherwise.
	 */
	tryMatchMaterialProduct = (ean, products) => {
		if (!this.parcelTableRef) return false;
		return this.parcelTableRef.applyMaterialProductToRow(ean, products);
	};

	findCheckbox = code => {
		if (!code) return null;
		return document.querySelector(
			`.produkt[data-barcode*="${CSS.escape(
				'#' + code + '#'
			)}"]:not(.blocked_by_serial) .checkbox.mainCheckbox:not(.checked),
		.produkt .bundleItemList .bundleItem[data-barcode*="${CSS.escape('#' + code + '#')}"] .checkbox:not(.checked)`
		);
	};

	selectCheckbox = (checkbox, ean, scanAsSingleQty) => {
		if (checkbox.classList.contains('checked')) {
			return;
		}
		const parent = checkbox.closest('.produkt.ramka');
		const counter = parent && parent.querySelector(`.bundleItemList .bundleItem[data-barcode*="#${ean}#"] .smaller.counter`);
		console.log('selectCheckbox', checkbox, parent, counter);
		if (scanAsSingleQty && counter) {
			let count = parseInt(counter.dataset.count) || 0;
			const qty = parseInt(counter.dataset.qtyUom) || 0;

			count++;
			updateCounter(counter, count);

			if (count >= qty) {
				this.toggleCheckbox(checkbox, parent, true);
			}
		} else {
			this.toggleCheckbox(checkbox, parent, true);
		}
	};

	handleScanNotFound = input => {
		wrong_ean_audio.play().catch(console.error);
		Popup.create({
			content: intl.get('Nie znaleziono produktu z tym kodem.'),
			buttons: {
				right: [
					{
						text: 'OK',
						className: 'ok',
						key: 'enter',
						action: () => {
							Popup.close();
							this.resetInput(input);
						},
					},
				],
			},
		});
	};

	playScanSound = () => {
		const audio = is_local_host_or_testerp ? speaky_peaky_one_audio : correct_scan_audio;
		audio.play().catch(console.error);
	};

	isUDI(parsedBarcode) {
		return parsedBarcode.type === 'UDI';
	}

	handleNonUDIPopup() {
		Popup.create({
			content: intl.get('Uwaga! Zeskanowany kod nie jest kodem UDI.'),
			buttons: {
				right: [
					{
						text: 'OK',
						className: 'ok',
						key: 'enter',
						action: () => {
							Popup.close();
							this.resetScanner();
						},
					},
				],
			},
		});

		wrong_ean_audio.play().catch(error => console.error('Wystąpił błąd podczas próby odtworzenia dźwięku:', error));
	}

	handleShortcut = barcode => {
		const shortcut = this.props.shortcuts && this.props.shortcuts.find(sc => sc.barcode === barcode);
		const { order_id } = this.props;
		if (!shortcut) return false;
		console.log(shortcut);

		switch (shortcut.action) {
			case 'next':
				if (this.state.valid && !this.state.processing) {
					this.handleShortagesOrSubmit();
				} else {
					console.log('Przycisk Dalej zablokowany!');
				}
				break;
			case 'back':
				this.deselectOrder();
				break;
			case 'set_all_packed':
				this.checkAllProducts(true);
				break;
			case 'mark_notes_read':
				this.markNotesRead();
				break;
			case 'add_package':
				if (!this.props.inventory_materials_shipment_package_sizes) {
					this.props.createNewShippingAction(order_id);
				} else {
					// this.addPackage();
				}
				break;
			case 'add_shipment':
				if (this.props.inventory_materials_shipment_package_sizes) {
					if (this.parcelTableRef) {
						this.parcelTableRef.addRow();
					}
				} else {
					this.props.createNewShippingAction(order_id);
				}
				break;
			default:
				console.warn(`Jeszcze nie zrobione ${shortcut.action}`);
		}

		return true;
	};

	resetScanner() {
		const scanner = document.getElementById('scanner');
		if (scanner) {
			scanner.value = '';
			scanner.focus();
		}
	}

	markNotesRead = () => {
		const $checkbox = document.querySelector('.uwagiCheckbox');
		if ($checkbox && !$checkbox.classList.contains('checked')) {
			$checkbox.click();
		}
	};

	sizePopupOld = (data, field_name, options) => {
		const self = this;
		let buttons = options.map(opt => ({
			text: opt[0],
			action: function () {
				Popup.close();
				data[field_name] = opt[1];
				self.handleFinishOrder(data);
			},
		}));
		buttons.push({
			text: intl.get('Anuluj'),
			className: 'cancel-button',
			action: function () {
				Popup.close();
			},
		});
		Popup.create({
			content: intl.get('Wybierz gabaryt paczki'),
			className: 'button-size-popup',
			buttons: {
				right: buttons,
			},
		});
	};

	sizePopup = (data, sizeOptions) => {
		const self = this;

		let buttons = sizeOptions.map(option => ({
			text: option.sizeName,
			children: option.sizeName,
			action: function () {
				Popup.close();
				data['dimensions'] = option.dimensions;
				self.handleFinishOrder(data);
			},
		}));

		buttons.push({
			text: intl.get('Pozostaw'),
			className: 'leave-button',
			children: intl.get('Pozostaw'),
			action: function () {
				Popup.close();
				self.handleFinishOrder(data);
			},
		});

		buttons.push({
			text: intl.get('Anuluj'),
			className: 'cancel-button',
			children: intl.get('Anuluj'),
			action: function () {
				Popup.close();
			},
		});

		Popup.create({
			content: intl.get('Wybierz gabaryt paczki'),
			className: 'additional-popup-class button-size-popup',
			buttons: {
				right: buttons,
			},
		});
	};

	handleFinishOrder(data) {
		const {
			finishOrderAction,
			packing_zone_inventory_manage_materials,
			material_products,
			packing_zone_dont_show_summary,
			finishOrderSkipSummaryAction,
		} = this.props;
		if (packing_zone_inventory_manage_materials && material_products.length) {
			Popup.plugins().materials(data, this);
			return;
		}
		if (packing_zone_dont_show_summary) {
			finishOrderSkipSummaryAction(data);
		} else {
			finishOrderAction(data);
		}
	}

	handleSubmit = event => {
		const {
			order,
			inpost_dostawy,
			orlen_dostawy,
			pp_dostawy,
			wza_dostawy,
			inventory_materials_shipment_package_sizes,
			packing_zone_editable_notes,
			simple_shipment_sizes,
		} = this.props;
		const { orderSubstitutes } = this.state;
		let data = {};
		let result = {};
		let order_id = order.id;

		if (inventory_materials_shipment_package_sizes) {
			const { isSelectDisabled, parcelRows, isNonStandardInputChecked } = this.state;

			if (!isSelectDisabled && parcelRows.length > 0) {
				const isAnySizeMissing = parcelRows.some(row => !row.size || row.size === '');

				if (isAnySizeMissing) {
					const errorIndexes = parcelRows
						.map((row, index) => (!row.size || row.size === '' ? index : null))
						.filter(index => index !== null);

					this.setState({ errorParcelIndexes: errorIndexes });

					Popup.create({
						content: intl.get('Proszę wybrać rozmiar paczki.'),
						buttons: {
							right: [
								{
									text: 'OK',
									className: 'ok',
									key: 'enter',
									action: () => Popup.close(),
								},
							],
						},
					});
					return;
				}
			}

			const carrier_id = this.state.selectedCarrierId || order.carrier_id;

			result = {
				carrier_id,
				order_id,
				parcels: parcelRows.map(row => {
					const parcel = { ...row };
					if (this.state.isSelectDisabled) {
						parcel.size_id = null;
						parcel.size = null;
						parcel.size_label = null;
					}
					return parcel;
				}),
				lots: data.lots || [],
				non_standard_checked: isNonStandardInputChecked,
			};
		}

		document.querySelectorAll('input').forEach(input => {
			if (input.type === 'radio' && !input.checked) {
				return;
			}
			let val = input.value;
			if (val !== '' && !isNaN(val)) {
				val = parseInt(val);
			}
			if (input.type === 'checkbox') {
				val = input.checked;
			}
			data[input.name] = val;
		});

		data['manual_confirmations'] = collectManualConfirmations();
		result.manual_confirmations = data.manual_confirmations;

		if (orderSubstitutes) {
			data['substitutes'] = Object.keys(orderSubstitutes).map(line_id => ({
				line_id: parseInt(line_id),
				original_qty: order.products.find(product => product.line_id === parseInt(line_id)).product_uom_qty,
				substitute_choosen: orderSubstitutes[line_id],
			}));
		}

		const serialValues = [];
		const serialRows = document.querySelectorAll('.serial_value');

		const serialItems = Array.from(serialRows).filter(row => row.dataset.isSerial === 'true');

		if (serialItems.length > 1) {
			const skuGroups = serialItems.reduce((groups, row) => {
				const sku = row.dataset.sku;
				if (!groups[sku]) {
					groups[sku] = [];
				}
				groups[sku].push(row.dataset.selectedLot);
				return groups;
			}, {});

			let conflictFound = false;

			Object.entries(skuGroups).forEach(([sku, lots]) => {
				const uniqueLots = new Set(lots);
				if (uniqueLots.size !== lots.length) {
					conflictFound = true;
					Popup.create({
						content: intl.get('sku_conflict', { sku }),
						buttons: {
							right: [
								{
									text: 'OK',
									className: 'ok',
									key: 'enter',
									action: function () {
										Popup.close();
									},
								},
							],
						},
					});
				}
			});

			if (conflictFound) {
				return;
			}
		}

		serialRows.forEach(val => {
			const lot = JSON.parse(val.innerHTML);
			const input = val.previousElementSibling.querySelector('input');
			const name = input ? input.name : undefined;

			if (name) {
				serialValues.push({ [name]: lot[0] });
			}
		});

		if (serialValues.length > 0) {
			data.lots = serialValues;
			result.lots = serialValues;
		}

		const parcelSizesInput = document.getElementById('parcelSizes');
		const parcelSizesValue = parcelSizesInput ? parcelSizesInput.value : '';

		if (packing_zone_editable_notes) {
			const inputNote = document.querySelector('textarea.note_text_input');
			if (inputNote) {
				const noteValue = inputNote.value;
				data.note = noteValue;
				result.note = noteValue;
			}
		}

		if (!inventory_materials_shipment_package_sizes) {
			const carrierId = data['carrier_id'] || order.carrier_id;
			// sizes configured on the carrier take precedence over the hardcoded carrier lists
			if (
				simple_shipment_sizes &&
				simple_shipment_sizes[carrierId] &&
				order.shipping_order_ids.some(el => {
					return (
						(typeof el.date === 'undefined' || !el.date) &&
						!el.shipping_parcels_ids.some(parcel => {
							const sizeId = Array.isArray(parcel.size) ? parcel.size[0] : parcel.size;
							return sizeId || parcelSizesValue;
						})
					);
				})
			) {
				const sizeOptions = simple_shipment_sizes[carrierId].map(size => {
					const dimensionsWithName = [size[0], ...size.slice(1)];
					return {
						sizeName: size[0],
						dimensions: dimensionsWithName,
					};
				});

				this.sizePopup(data, sizeOptions);
			} else if (
				carrierId &&
				inpost_dostawy.includes(carrierId) &&
				order.shipping_order_ids.some(el => {
					return (
						(typeof el.date === 'undefined' || !el.date) &&
						!el.shipping_parcels_ids.some(parcel => {
							const sizeId = Array.isArray(parcel.size) ? parcel.size[0] : parcel.size;
							return sizeId || parcelSizesValue;
						})
					);
				})
			) {
				if (!parcelSizesValue) {
					this.sizePopupOld(data, 'inpost_size', inpost_size_options);
				}
			} else if (
				carrierId &&
				orlen_dostawy.includes(carrierId) &&
				order.shipping_order_ids.some(el => {
					return (
						(typeof el.date === 'undefined' || !el.date) &&
						!el.shipping_parcels_ids.some(parcel => {
							const sizeId = Array.isArray(parcel.size) ? parcel.size[0] : parcel.size;
							return sizeId || parcelSizesValue;
						})
					);
				})
			) {
				this.sizePopupOld(data, 'orlen_size', orlen_size_options);
			} else if (
				carrierId &&
				pp_dostawy.includes(carrierId) &&
				order.shipping_order_ids.some(el => {
					return (
						(typeof el.date === 'undefined' || !el.date) &&
						!el.shipping_parcels_ids.some(parcel => {
							const sizeId = Array.isArray(parcel.size) ? parcel.size[0] : parcel.size;
							return sizeId || parcelSizesValue;
						})
					);
				})
			) {
				this.sizePopupOld(data, 'pp_size', pp_size_options);
			} else if (
				carrierId &&
				wza_dostawy.includes(carrierId) &&
				order.shipping_order_ids.some(el => {
					return (
						(typeof el.date === 'undefined' || !el.date) &&
						!el.shipping_parcels_ids.some(parcel => {
							const sizeId = Array.isArray(parcel.size) ? parcel.size[0] : parcel.size;
							return sizeId || parcelSizesValue;
						})
					);
				})
			) {
				this.sizePopupOld(data, 'wza_size', wza_size_options);
			} else {
				this.handleFinishOrder(data);
			}
		} else {
			this.handleFinishOrder(result);
		}
	};

	handleShortagesOrSubmit = () => {
		const { shortagesButtonClicked, selectedCarrierId } = this.state;
		const { inventory_materials_shipment_package_sizes, available_carriers, order } = this.props;

		const carrierId = selectedCarrierId || order.carrier_id;
		const selectedCarrier = available_carriers.find(c => c.id === carrierId);
		const skipParcelValidation = selectedCarrier && selectedCarrier.external_integration;

		if (!skipParcelValidation) {
			const weightInputs = document.querySelectorAll('.parcels.table input[name^="weight_"][type="number"]');
			const areWeightsValid = Array.from(weightInputs).every(input => input.value !== '' && input.value !== '0');
			const tableBody = document.querySelector('.parcels.table tbody');
			const hasRows = tableBody && tableBody.rows.length > 0;

			if (!areWeightsValid || (inventory_materials_shipment_package_sizes && !hasRows)) {
				Popup.create({
					content: intl.get('Złe dane przesyłki lub ich brak!'),
					buttons: {
						right: [
							{
								text: 'OK',
								className: 'ok',
								key: 'enter',
								action: () => Popup.close(),
							},
						],
					},
				});
				return;
			}
		}

		if (shortagesButtonClicked) {
			const productsWithShortages = getProductsWithShortages();
			const note = getShortagesNote();
			this.handleShortagesOrder(productsWithShortages, note);
		} else {
			this.handleSubmit();
		}
	};

	toggleConfirmButton = () => {
		const { progress: prevProgress, valid: prevValid, shortagesButtonClicked, shortagesNextPoint } = this.state;
		const state = {};
		const { close_order_in_packing_zone_after_all_products_scanned } = this.props

		// Shortages button logic
		if (shortagesButtonClicked && shortagesNextPoint) {
			this.setState({ progress: 100, valid: true });
			return;
		}

		// Default progress and valid state
		state.progress = 0;
		state.valid = false;

		const allMainCheckboxes = document.querySelectorAll('.produkt .mainCheckbox, .mainCheckbox.uwagiCheckbox');
		let checkedCount = 0;

		allMainCheckboxes.forEach(checkbox => {
			const produktEl = checkbox.closest('.produkt');
			const hasUnselectedVariant = produktEl && produktEl.querySelector('.productVariantValue.proper:not(.selected)');

			if (!hasUnselectedVariant && checkbox.classList.contains('checked')) {
				checkedCount++;
			}
		});

		const allCount = allMainCheckboxes.length;
		state.progress = allCount > 0 ? (checkedCount / allCount) * 100 : 100;

		// If all products checked set valid true
		if (state.progress === 100) {
			state.valid = true;
			const audio = is_local_host_or_testerp ? speaky_peaky_two_audio : finish_packing_audio;
			audio.play().catch(err => console.error('Audio play error:', err));
		}

		// If state has changed update the state
		if (state.progress !== prevProgress || state.valid !== prevValid) {
			const justCompletedByScanning =
			    close_order_in_packing_zone_after_all_products_scanned &&
				allCount > 0 &&
				!shortagesButtonClicked &&
				state.progress === 100 &&
				prevProgress !== 100;

			this.setState(state, () => {
				if (justCompletedByScanning) {
					const confirmButton = document.getElementById('zatwierdz');
					if (confirmButton) confirmButton.click();
				}
			});
		}
	};

	showShipping = id => {
		const { selectShippingAction } = this.props;
		selectShippingAction(id);
	};

	newShipping = () => {
		const { selectShippingAction } = this.props;
		selectShippingAction(0);
		return;
	};

	deleteShipping = shippingId => {
		const { deleteShippingAction } = this.props;
		Popup.create(
			{
				content: intl.get('Czy na pewno chcesz usunąć przesyłkę?'),
				buttons: {
					right: [
						{
							text: intl.get('Tak'),
							className: 'ok',
							key: 'enter',
							action: function () {
								deleteShippingAction(shippingId);
							},
						},
						{
							text: intl.get('Anuluj'),
							className: 'cancel-button',
							action: function () {
								Popup.close();
							},
						},
					],
				},
			},
			true
		);
	};

	generateReturnWaybill = shippingId => {
		const { generateReturnWaybillAction } = this.props;
		Popup.create(
			{
				content: intl.get('Czy na pewno chcesz wygenerować etykietę zwrotną?'),
				buttons: {
					right: [
						{
							text: intl.get('Tak'),
							className: 'ok',
							key: 'enter',
							action: function () {
								generateReturnWaybillAction(shippingId);
							},
						},
						{
							text: intl.get('Anuluj'),
							className: 'cancel-button',
							action: function () {
								Popup.close();
							},
						},
					],
				},
			},
			true
		);
	};

	shippingList = () => {
		Popup.plugins().shipping(
			this.newShipping,
			this.deleteShipping,
			this.generateReturnWaybill,
			this.props.show_generate_return_waybill,
			this
		);
	};

	shippingDataPopup = async () => {
		const { order, getShippingAction } = this.props;
		if (order.shipping_order_ids && order.shipping_order_ids.length > 0) {
			const shippingId = order.shipping_order_ids[0].id;
			try {
				const shippingData = await getShippingAction(shippingId, order.id);
				Popup.plugins().shippingData(order, shippingData, this.saveShippingData);
			} catch (error) {
				console.error('Error fetching shipping data:', error);
			}
		} else {
			Popup.plugins().shippingData(order, null, this.saveShippingData);
		}
	};

	saveShippingData = (data) => {
		const { order, saveShippingAction } = this.props;
		if (order.shipping_order_ids && order.shipping_order_ids.length > 0) {
			const shippingId = order.shipping_order_ids[0].id;
			const shippingData = {
				receiver_name: data.delivery_name,
				receiver_street: data.delivery_street,
				receiver_zip: data.delivery_zip,
				receiver_city: data.delivery_city,
				receiver_phone: data.delivery_phone,
				receiver_email: data.delivery_email,
			};
			saveShippingAction(shippingId, shippingData, order.id)
				.then(() => {
					this.setState({ deliveryData: data });
					this.deliveryDataLoadedForOrder = order.id;
				})
				.catch(() => {});
		}
		Popup.close();
	};

	noteCheckboxClick = event => {
		let $checkbox = event.currentTarget;
		if ($checkbox.tagName === 'DIV') {
			$checkbox = $checkbox.parentElement.querySelector('.uwagiCheckbox');
		}
		if ($checkbox) {
			$checkbox.classList.toggle('checked');
			this.toggleConfirmButton();
		}
	};

	setOrderSubstitutes = (line_id, substitutes) => {
		const { orderSubstitutes } = this.state;
		this.setState({
			orderSubstitutes: {
				...orderSubstitutes,
				[line_id]: substitutes,
			},
		});
	};

	getOrderSubstitutes = line_id => {
		const { orderSubstitutes } = this.state;
		return orderSubstitutes[line_id];
	};

	checkAllProducts = (skipScanRequired = false) => {
		const productBoxes = document.querySelectorAll('.product_checkbox');

		productBoxes.forEach(box => {
			if (skipScanRequired && isElementScanRequired(box.closest('.produkt.ramka'))) {
				return;
			}
			const mainCheckbox = box.querySelector('.checkbox.mainCheckbox');
			const counter = box.querySelector('.grouped_counter_count');
			const bundleWrapper = box.closest('.bundleWrapper');

			if (counter) {
				const required = Number(counter.dataset.destination) || 1;
				let current = Number(counter.dataset.count) || 0;

				while (current < required) {
					this.incrementGroupedCounter(box);
					current++;
				}
			} else if (bundleWrapper) {
				const multiproductCheckboxes = bundleWrapper.querySelectorAll('.checkbox.multiproduct');
				multiproductCheckboxes.forEach(mpCheckbox => {
					if (skipScanRequired && isElementScanRequired(mpCheckbox.closest('.bundleItem'))) {
						return;
					}
					if (!mpCheckbox.classList.contains('checked')) {
						this.toggleCheckbox(mpCheckbox, bundleWrapper);
					}
				});
			} else if (mainCheckbox && !mainCheckbox.classList.contains('checked')) {
				this.toggleCheckbox(mainCheckbox, box);
			}
		});
	};

	handleShortagesButtonClick = () => {
		const checkboxes = document.querySelectorAll('.product_checkbox');
		const sumbitButton = document.querySelector('#zatwierdz');
		const productWrapper = document.querySelector('.produkt.ramka');

		checkboxes.forEach(checkbox => {
			const checkboxesInsideProductCheckbox = checkbox.querySelectorAll('.checkbox');
			if (checkbox.classList.contains('product_checkbox_red')) {
				checkbox.classList.remove('product_checkbox_red');
				checkbox.querySelector('.shortages-container').remove();
				productWrapper.classList.remove('is-shortages');
				sumbitButton.classList.contains('shortages');
				sumbitButton.classList.remove('shortages');
				checkboxesInsideProductCheckbox.forEach(checkbox => {
					checkbox.style.display = 'flex';
					checkbox.style.pointerEvents = 'all';
				});
				this.setState({ shortagesButtonClicked: false }, () => {});
			} else {
				checkboxesInsideProductCheckbox.forEach(checkbox => {
					checkbox.style.display = 'none';
					checkbox.style.pointerEvents = 'none';
					if (checkbox.classList.contains('checked')) {
						checkbox.classList.remove('checked');
					}
				});
				this.setState({ shortagesButtonClicked: true }, () => {});
				checkbox.classList.add('product_checkbox_red');
				sumbitButton.classList.add('shortages');

				const productDetails = checkbox.closest('.ramka.produkt');
				productDetails.classList.add('is-shortages');
				const qty = parseInt(productDetails.querySelector('.qty.f_group > div').textContent);
				const container = document.createElement('div');
				container.className = 'shortages-container';

				const addButton = document.createElement('button');
				addButton.textContent = '+';
				addButton.className = 'increment-button';
				addButton.addEventListener('click', () => {
					if (parseInt(shortagesInput.value) < qty) {
						shortagesInput.value = parseInt(shortagesInput.value) + 1;
						this.checkInputValue();
					}
				});
				container.appendChild(addButton);

				const shortagesInput = document.createElement('input');
				shortagesInput.type = 'number';
				shortagesInput.className = 'shortages-input';
				shortagesInput.value = '0';
				shortagesInput.min = '0';
				shortagesInput.max = qty;
				shortagesInput.disabled = true;
				container.appendChild(shortagesInput);

				const subtractButton = document.createElement('button');
				subtractButton.textContent = '-';
				subtractButton.className = 'decrement-button';
				subtractButton.addEventListener('click', () => {
					if (parseInt(shortagesInput.value) > 0) {
						shortagesInput.value = parseInt(shortagesInput.value) - 1;
						this.checkInputValue();
					}
				});
				container.appendChild(subtractButton);

				checkbox.appendChild(container);
			}
		});

		this.checkInputValue();
	};

	handleParcelsChange = rows => {
		this.setState({ parcelRows: rows });
	};

	handleCarrierChange = selectedCarrierId => {
		this.setState({ selectedCarrierId });
	};

	handleSelectDisabledChange = isSelectDisabled => {
		this.setState({ isSelectDisabled });
	};

	clearErrorRow = index => {
		this.setState(prev => ({
			errorParcelIndexes: prev.errorParcelIndexes.filter(i => i !== index),
		}));
	};

	render() {
		const { authenticated } = this.props;
		if (!authenticated) return <Redirect to='/login' />;
		const odoo = window.ODOO.url + (window.ODOO.port ? ':' + window.ODOO.port : '');
		const {
			order,
			pack,
			product_confirmation_method,
			show_company,
			use_packing_zone_error_label,
			show_shop,
			confirm_note,
			carrier_selection,
			group_treshold,
			add_delivery,
			add_package,
			processing,
			product_shortages_in_packing_zone,
			inventory_materials_shipment_package_sizes,
			available_carriers,
			show_package_button_in_packing_zone,
			packing_zone_editable_notes,
			packing_zone_show_cod_warning_popup,
		} = this.props;
		const { progress, valid } = this.state;
		const deliveryData = order ? this.getDeliveryDataForDisplay(order) : {};
		const deliveryName = deliveryData.delivery_name || '';
		const deliveryStreet = deliveryData.delivery_street || '';
		const deliveryZip = deliveryData.delivery_zip || '';
		const deliveryCity = deliveryData.delivery_city || '';
		const deliveryPhone = deliveryData.delivery_phone || '';
		const deliveryEmail = deliveryData.delivery_email || '';
		const deliveryDiff = order ? this.getDeliveryDiff(order, deliveryData) : {};
		const hasDeliveryDiff = this.hasAnyDeliveryDiff(deliveryDiff);
		return (
			<>
				<ProgressBar percent={progress} />
				<div className='pakowanie'>
					<style
						dangerouslySetInnerHTML={{
							__html: `
          #app header, #app footer{ display: none }
          #app{ display: block }
        `,
						}}
					/>
					<div>
						<div className='pakowanie_header'>
							<button className='pull-left secondary' onClick={this.deselectOrder}>
								{intl.get('Wstecz')}
							</button>
							{product_shortages_in_packing_zone && (
								<button className='shortages-btn secondary text-red' onClick={this.handleShortagesButtonClick}>
									{intl.get('Braki')}
								</button>
							)}
							{['scan', 'scan_click'].includes(product_confirmation_method) && (
								<div className='scanner_wrapper'>
									<input
										id='scanner'
										type='text'
										name='scanner'
										placeholder={intl.get('Wprowadź kod produktu')}
										onKeyPress={this.handleScanner}
										autoComplete='off'
									/>
								</div>
							)}
							<button
								onClick={this.handleShortagesOrSubmit}
								className='pull-right'
								id='zatwierdz'
								disabled={!valid || processing}>
								{intl.get('Dalej')}
							</button>
						</div>
						{order && (
							<div className='pakowanie_content row'>
								<input type='hidden' name='order_id' value={order.id} />
								<input type='hidden' name='paczka' value={pack} />
								<div className='col-lg-5'>
									<div className='pakowanie_order ramka'>
										<h4>
											{intl.get('Zamówienie')} {order.name}
										</h4>
										<div className='order_data'>
											{packing_zone_show_cod_warning_popup && order.is_cod && (
												<div className='warning f_group'>{intl.get('Płatność za pobraniem')}</div>
											)}
											<div className='notes f_group'>
												<label>{intl.get('Uwagi klienta')}:</label>
												<div>
													{confirm_note && order.note && (
														<div className='checkbox mainCheckbox uwagiCheckbox' onClick={this.noteCheckboxClick}>
															<Check className='check' />
														</div>
													)}

													{packing_zone_editable_notes ? (
														<textarea className='note_text_input' defaultValue={order.note || ''} />
													) : (
														<div className='note_text' onClick={this.noteCheckboxClick}>
															{order.note}
														</div>
													)}
												</div>
											</div>
											{order.internal_picking_note && (
												<div className='notes f_group internal-note'>
													<label>{intl.get('Notatka wewnętrzna')}:</label>
													<div className='note_text'>{order.internal_picking_note}</div>
												</div>
											)}

											{inventory_materials_shipment_package_sizes && (
												<ParcelTable
													ref={ref => (this.parcelTableRef = ref)}
													available_carriers={available_carriers}
													order={order}
													onNonStandardCheckedChange={this.handleNonStandardCheckedChange}
													onParcelsChange={this.handleParcelsChange}
													onCarrierChange={this.handleCarrierChange}
													selectedCarrierId={this.state.selectedCarrierId || order.carrier_id}
													rowsWithErrors={this.state.errorParcelIndexes}
													clearErrorRow={this.clearErrorRow}
													showGenerateReturnWaybill={this.props.show_generate_return_waybill}
													generateReturnWaybill={this.generateReturnWaybill}
													onSelectDisabledChange={this.handleSelectDisabledChange}
												/>
											)}

											{!inventory_materials_shipment_package_sizes && (
												<div className='carrier f_group'>
													<label>{intl.get('Metoda dostawy')}:</label>
													{carrier_selection && order.carriers && (
														<div className='carriers_radios'>
															{order.carriers.map(carrier => (
																<div className='carrier_radio' key={carrier.id}>
																	<div
																		className='carrier_thumbnail'
																		style={{
																			color: '#ccc',
																			backgroundImage: `url("${handleLogoUrl(carrier.carrier_comp)}")`,
																		}}
																	/>
																	<input
																		type='radio'
																		name='carrier_id'
																		id={'carrier_' + carrier.id}
																		value={carrier.id}
																		defaultChecked={order.carrier_id === carrier.id ? 'checked' : ''}
																	/>
																	<label
																		className={order.carrier_id === carrier.id ? 'initial' : ''}
																		htmlFor={'carrier_' + carrier.id}
																		onClick={this.confirmCarrierChange}
																		data-value={carrier.id}>
																		{carrier.name}
																	</label>
																</div>
															))}
														</div>
													)}
													<div>
														{order.carrier_name}
														{inventory_materials_shipment_package_sizes && (
															<select>
																<option>1</option>
																<option>2</option>
															</select>
														)}
														<div>
															<input type='hidden' name='carrier_id' value={order.carrier_id || ''} />
															{order.carrier_comp && (
																<span className='shippinglogo'>
																	<img src={handleLogoUrl(order.carrier_comp)} alt='carrier' />
																	<br />
																</span>
															)}
														</div>
													</div>
													{(add_package || add_delivery) && (
														<div className='add_package_wrapper'>
															{add_delivery && (
																<button id='add_delivery' onClick={this.addDelivery}>
																	{intl.get('Dodaj przesyłkę')}
																</button>
															)}
															{add_package && (
																<button id='add_package' onClick={this.addPackage}>
																	{intl.get('Dodaj paczkę')}
																</button>
															)}
														</div>
													)}
												</div>
											)}

											{order.shipping_parcel_count && (
												<div className='carrier f_group'>
													<label>{intl.get('Ilość paczek')}:</label>
													<div>{order.shipping_parcel_count}</div>
												</div>
											)}
											{show_company && (
												<div className='date_order f_group'>
													<label>{intl.get('Firma')}:</label>
													<div>{order.company}</div>
												</div>
											)}
											{show_shop && (
												<div className='date_order f_group'>
													<label>{intl.get('Sklep')}:</label>
													<div>{order.shop_name}</div>
												</div>
											)}
											{order.packing_zone_cart_names.length > 0 && (
												<div className='date_order f_group'>
													<label>{intl.get('Wózki')}:</label>
													<div>{order.packing_zone_cart_names}</div>
												</div>
											)}
											<div className='date_order f_group'>
												<label>{intl.get('Data zamówienia')}:</label>
												<div>{order.date_order}</div>
											</div>
											<div className='amount_total f_group'>
												<label>{intl.get('Kwota zamówienia')}:</label>
												<div>{order.amount_total}</div>
											</div>
											{order.integration_login && (
												<div className='integration_login f_group'>
													<label>{intl.get('Login klienta')}:</label>
													<div>{order.integration_login}</div>
												</div>
											)}
											{order.allegro_account && (
												<div className='allegro_account f_group'>
													<label>{intl.get('Login Allegro sprzedawcy')}:</label>
													<div>{order.allegro_account}</div>
												</div>
											)}
											<div className='delivery f_group'>
												<label>{intl.get('Adres dostawy')}:</label>
												<div>
													{hasDeliveryDiff && <div className='changed-legend'>{intl.get('Zmienione dane')}</div>}
													<div className={deliveryDiff.name ? 'field--edited' : ''}>{deliveryName}</div>
													<div className={deliveryDiff.street ? 'field--edited' : ''}>{deliveryStreet}</div>
													<div className={deliveryDiff.zip || deliveryDiff.city ? 'field--edited' : ''}>
														{deliveryZip} {deliveryCity}
													</div>
													{deliveryPhone && <div className={deliveryDiff.phone ? 'field--edited' : ''}>{deliveryPhone}</div>}
													{deliveryEmail && <div className={deliveryDiff.email ? 'field--edited' : ''}>{deliveryEmail}</div>}
												</div>
											</div>
											<div className='invoice f_group'>
												<label>{intl.get('Potwierdzenie')}:</label>
												<div>{order.invoice_option_doc ? intl.get(order.invoice_option_doc) : intl.get('other')}</div>
											</div>
											{order.warehouseman && (
												<div className='warehouseman f_group'>
													<label>{intl.get('Osoba zbierająca')}:</label>
													<div>{order.warehouseman}</div>
												</div>
											)}
										</div>
										<div className='text-center buttons_wrap'>
										<div>
											<input type='hidden' id='parcelSizes' />
											{inventory_materials_shipment_package_sizes && (
												<button onClick={this.shippingDataPopup}>{intl.get('Przesyłki')}</button>
											)}

											{!inventory_materials_shipment_package_sizes && (
												<button onClick={this.shippingList}>{intl.get('Przesyłki')}</button>
											)}
											
											{use_packing_zone_error_label && (
												<button className='secondary' onClick={this.printErrorLabel}>
													{intl.get('Drukuj etykietę zastępczą')}
												</button>
											)}
											{show_package_button_in_packing_zone && (
												<a href={order.package_url} target='_blank' rel='noopener noreferrer'>
													<button>{intl.get('Przejdź do pakietu')}</button>
												</a>
											)}
										</div>
									</div>
									</div>
								</div>
								<div className={'pakowanie_products col-lg-7' + (order.products.length > 3 ? ' many_products' : '')}>
									{order.products.map((product, index) => getProductListItem(product, this, group_treshold || 10, index))}
								</div>
							</div>
						)}
					</div>
				</div>
			</>
		);
	}
}
const Order = connect(mapStateToProps, mapDispatchToProps)(OrderComponent);
export default withRouter(Order);
